import * as Api from '@Api/index';
import { BackendError } from '@Common/errors';

import type { ApiResponse } from '@Types/Api';
import type { ConfiguratorData } from '@Pages/PageProduct';

export interface Params {
  slug: string;
}

async function getPreConfigurator(params: Params, opts?: RequestInit) {
  const { slug } = params;
  const { pathname, search } = new URL(slug, 'http://base-url/');
  const translite = pathname.split('/product/');
  const searchParams = new URLSearchParams(search);
  const paramsObject = {};

  searchParams.forEach((value, key) => {
    paramsObject[key] = value;
  });

  const url = `/backend/product/configurator/${translite[1]}`;

  const res = await Api.queryProxi<ApiResponse<ConfiguratorData>>(url, {
    ...opts,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(paramsObject),
  });

  if (!res?.ok) throw new BackendError(url, res);

  return res.data;
}

export default getPreConfigurator;
